import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as tasksReducer from "containers/Tasks/TasksReducer";
import * as projectReducer from "containers/Project/reducer";
import * as homeReducer from "containers/Home/reducer";

import Task from "components/Tasks/Task";

const getTaskId = (props) =>
  props && props.taskId
    ? props.taskId
    : props && props.match && props.match.params && props.match.params.taskId
      ? props.match.params.taskId
      : "new";

class TaskContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    props.init();
  }

  render() {
    const { id } = this.props;

    return <Task {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const taskId = getTaskId(ownProps);

  return {
    init: () => dispatch(tasksReducer.init(taskId)),
    saveVersion: (task) => dispatch(tasksReducer.saveVersion(task)),
    editFeedback: (id, node, edits) => dispatch(nextReducer.editFeedback(id, node, edits)),
    deleteFeedback: (id, node, edits) => dispatch(nextReducer.deleteFeedback(id, node, edits))
  };
};

const mapStateToProps = (state, ownProps) => {
  const taskId = getTaskId(ownProps);
  const projectId = tasksReducer.getProjectIdFromTask(state, taskId);

  const nextId = nextReducer.getNextIdFromProjectId(state, projectId);

  const activeSegment = projectReducer.getActiveSegment(state, projectId);
  const optimized = projectReducer.getOptimized(state, projectId);
  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : projectId;

  const task = tasksReducer.getTask(state, taskId);
  const splitTasks = tasksReducer.getSplitTasks(state, taskId);

  const fTask =
    splitTasks === undefined
      ? undefined
      : splitTasks.find(
          (sTask) =>
            activeSegment?.id !== undefined && sTask?.task?.projects?.[0]?.segments?.[0]?.id === activeSegment?.id
        );

  const selectedTask = fTask !== undefined ? { ...fTask?.task, segment: { ...fTask?.segment } } : task;

  const assign = nextModelsReducer.getNodeAssign(state, nextId);
  const comments = nextModelsReducer.getComments(state, nextId);

  const dataset = homeReducer.getDataset(state, projectReducer.getDatasetId(state, projectId));

  return {
    nextId: nextId,
    task: task,
    splitTasks: splitTasks,
    selectedTask: selectedTask,
    project: tasksReducer.getProjectFromTask(state, taskId),
    dataset: dataset,

    projectId: projectId,
    optimized: projectReducer.getOptimized(state, projectId),
    runId: runId,

    isOverallSegment: projectReducer.getIsOverallSegment(state, projectId, runId),
    assign: assign,
    comments: comments,
    hasLoadedDataset: homeReducer.getIsExploreReady(state, dataset.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TaskContainer);
